const findFundByContractNumber = (investmentFunds, contractNumber) =>
    investmentFunds.find(fund => fund.getIn(['contrato', 'numerodecontrato']) === contractNumber);

const getFundId = (fund) => {
    const productSubtype = fund.getIn(['criterios', 'c1', 'subtipoproducto']);
    const product = fund.getIn(['contrato', 'producto']);
    return `${product}-${productSubtype}-1`;
};

const getFundDataForImposition = (fund) => ({
    amountObject: {
        amount: fund && fund.getIn(['saldo1', 'importe']) || 0,
        currency: fund && fund.getIn(['saldo1', 'divisa']) || ''
    },
    description: fund && fund.get('descripcion') || ''
});

module.exports = {
    findFundByContractNumber,
    getFundDataForImposition,
    getFundId
};
